module.exports = __webpack_public_path__ + "img/tcn.1a898d7a.jpg";